import { jsx } from "react/jsx-runtime";
import { TextButton, Button as Button$1 } from "@zillow/constellation-10";
import { IconArrowDownOutline as ForwardRef$f } from "../../node_modules/@zillow/constellation-icons/dist/react/outline/icon-arrow-down-outline.esm.js";
import { IconArrowLeftOutline as ForwardRef$e } from "../../node_modules/@zillow/constellation-icons/dist/react/outline/icon-arrow-left-outline.esm.js";
import { IconArrowRightOutline as ForwardRef$d } from "../../node_modules/@zillow/constellation-icons/dist/react/outline/icon-arrow-right-outline.esm.js";
import { IconArrowUpOutline as ForwardRef$c } from "../../node_modules/@zillow/constellation-icons/dist/react/outline/icon-arrow-up-outline.esm.js";
import { IconMailFilled as ForwardRef$5 } from "../../node_modules/@zillow/constellation-icons/dist/react/filled/icon-mail-filled.esm.js";
import { IconMailOutline as ForwardRef$b } from "../../node_modules/@zillow/constellation-icons/dist/react/outline/icon-mail-outline.esm.js";
import { IconPlayCircleFilled as ForwardRef$3 } from "../../node_modules/@zillow/constellation-icons/dist/react/filled/icon-play-circle-filled.esm.js";
import { IconPlayCircleOutline as ForwardRef$a } from "../../node_modules/@zillow/constellation-icons/dist/react/outline/icon-play-circle-outline.esm.js";
import { IconPlayFilled as ForwardRef$4 } from "../../node_modules/@zillow/constellation-icons/dist/react/filled/icon-play-filled.esm.js";
import { IconPlayOutline as ForwardRef$9 } from "../../node_modules/@zillow/constellation-icons/dist/react/outline/icon-play-outline.esm.js";
import { IconPointerDownFilled as ForwardRef$2 } from "../../node_modules/@zillow/constellation-icons/dist/react/filled/icon-pointer-down-filled.esm.js";
import { IconPointerDownOutline as ForwardRef$8 } from "../../node_modules/@zillow/constellation-icons/dist/react/outline/icon-pointer-down-outline.esm.js";
import { IconPointerUpFilled as ForwardRef$1 } from "../../node_modules/@zillow/constellation-icons/dist/react/filled/icon-pointer-up-filled.esm.js";
import { IconPointerUpOutline as ForwardRef$7 } from "../../node_modules/@zillow/constellation-icons/dist/react/outline/icon-pointer-up-outline.esm.js";
import { IconSmartphoneFilled as ForwardRef } from "../../node_modules/@zillow/constellation-icons/dist/react/filled/icon-smartphone-filled.esm.js";
import { IconSmartphoneOutline as ForwardRef$6 } from "../../node_modules/@zillow/constellation-icons/dist/react/outline/icon-smartphone-outline.esm.js";
import { event } from "@zillow/universal-analytics";
import { yieldCallback } from "@zillow/yield-callback";
import { usePageProps, resolveSpacing, getButtonMinWidth, getCmsInfoForPage } from "@zillow/zrs-cms";
import { withTrigger } from "../../util/helpers.esm.js";
import { usePopulateParamPlaceHolders } from "../../util/populateParamPlaceholders.esm.js";
const WrappedButton = withTrigger(Button$1);
const WrappedTextButton = withTrigger(TextButton);
const IconList = {
  IconArrowDownOutline: ForwardRef$f,
  IconArrowLeftOutline: ForwardRef$e,
  IconArrowRightOutline: ForwardRef$d,
  IconArrowUpOutline: ForwardRef$c,
  IconMailFilled: ForwardRef$5,
  IconMailOutline: ForwardRef$b,
  IconPlayCircleFilled: ForwardRef$3,
  IconPlayCircleOutline: ForwardRef$a,
  IconPlayFilled: ForwardRef$4,
  IconPlayOutline: ForwardRef$9,
  IconPointerDownFilled: ForwardRef$2,
  IconPointerDownOutline: ForwardRef$8,
  IconPointerUpFilled: ForwardRef$1,
  IconPointerUpOutline: ForwardRef$7,
  IconSmartphoneFilled: ForwardRef,
  IconSmartphoneOutline: ForwardRef$6,
  // Legacy aliases — backward compat for blocks that stored bare icon names
  IconMail: ForwardRef$5,
  IconPlay: ForwardRef$4,
  IconPlayCircle: ForwardRef$3,
  IconPointerDown: ForwardRef$2,
  IconPointerUp: ForwardRef$1,
  IconSmartphone: ForwardRef
};
const BUTTON_TYPE_MAP = {
  primary: {
    tone: "brand",
    emphasis: "filled"
  },
  secondary: {
    tone: "brand",
    emphasis: "outlined"
  },
  tertiary: {
    tone: "neutral",
    emphasis: "outlined"
  },
  caution: {
    tone: "critical",
    emphasis: "filled"
  }
};
const TEXT_BUTTON_TYPE_MAP = {
  primary: {
    tone: "brand"
  },
  secondary: {
    tone: "neutral"
  },
  tertiary: {
    tone: "subtle"
  },
  caution: {
    tone: "critical"
  }
};
const SPACING_PROP_NAMES = ["margin", "marginTop", "marginRight", "marginBottom", "marginLeft", "padding", "paddingTop", "paddingRight", "paddingBottom", "paddingLeft"];
function isLinkObject(link) {
  return typeof link === "object" && link !== null && "url" in link;
}
const BlockButton = (props) => {
  const pageProps = usePageProps();
  const {
    attrs,
    index
  } = props;
  const {
    content = "Button Text",
    link,
    component = "Button",
    icon,
    fixedWidth,
    size = "md",
    style,
    css: cssProp,
    // v8 legacy props — migrated below for backward compat
    buttonType = "primary",
    inverse,
    // v10 props — passed through directly if already present
    tone,
    emphasis,
    onImpact,
    ...restAttrs
  } = attrs;
  const spacingCss = {};
  const cleanedAttrs = {};
  for (const [key, val] of Object.entries(restAttrs)) {
    if (SPACING_PROP_NAMES.includes(key)) {
      const migrated = resolveSpacing(val);
      if (migrated !== void 0) spacingCss[key] = migrated;
    } else {
      cleanedAttrs[key] = val;
    }
  }
  const resolvedOnImpact = onImpact ?? (inverse || false);
  const resolvedToneEmphasis = (() => {
    if (tone || emphasis) return {
      tone,
      emphasis
    };
    if (component === "TextButton") {
      if (resolvedOnImpact) return {
        tone: "neutral"
      };
      return TEXT_BUTTON_TYPE_MAP[buttonType] || TEXT_BUTTON_TYPE_MAP.primary;
    }
    const mapped = BUTTON_TYPE_MAP[buttonType] || BUTTON_TYPE_MAP.primary;
    if (resolvedOnImpact && mapped.tone === "brand" && mapped.emphasis === "outlined") {
      return {
        tone: "neutral",
        emphasis: "outlined"
      };
    }
    return mapped;
  })();
  const ButtonWithTrigger = component === "TextButton" ? WrappedTextButton : WrappedButton;
  const IconComponent = icon ? IconList[icon] : null;
  const migratedCssProp = cssProp ? Object.fromEntries(Object.entries(cssProp).map(([k, v]) => [k, SPACING_PROP_NAMES.includes(k) ? resolveSpacing(v) ?? v : v])) : void 0;
  const mergedCss = {
    ...spacingCss,
    ...migratedCssProp
  };
  const {
    emphasis: _emphasis,
    ...toneOnly
  } = resolvedToneEmphasis;
  const toneEmphasis = component === "TextButton" ? toneOnly : resolvedToneEmphasis;
  const attributes = {
    size,
    iconPosition: "end",
    ...toneEmphasis,
    onImpact: resolvedOnImpact,
    ...cleanedAttrs,
    icon: IconComponent ? /* @__PURE__ */ jsx(IconComponent, {}) : void 0,
    style: {
      ...style,
      minWidth: getButtonMinWidth({
        fixedWidth,
        size,
        component
      })
    },
    ...Object.keys(mergedCss).length > 0 ? {
      css: mergedCss
    } : {}
  };
  const linkUrl = isLinkObject(link) ? link.url : link;
  const opensInNewTab = isLinkObject(link) ? link.opensInNewTab : void 0;
  const href = usePopulateParamPlaceHolders(linkUrl || (typeof link === "string" ? link : void 0));
  if (link) {
    return /* @__PURE__ */ jsx(ButtonWithTrigger, { triggerLink: linkUrl || link, asChild: true, ...attributes, onMouseEnter: () => {
      event({
        envelope: {
          event_type_id: "2049",
          event_type_version_id: "1",
          event_template_id: "126",
          event_template_version_id: "1"
        },
        clickstream_trigger: {
          trigger_type_nm: "interaction",
          trigger_location_nm: "cms",
          trigger_source_nm: "cms_button",
          trigger_object_nm: "no_trigger_object"
        },
        semantic: {
          semantic_event_nm: "cms_hover"
        },
        cms_info: {
          block_id: attributes.id || "",
          block_type_cd: "button",
          block_displayed_txt: content,
          block_target_url: linkUrl || link,
          block_target_window_txt: opensInNewTab ? "_blank" : "",
          ...getCmsInfoForPage(pageProps)
        }
      });
    }, onClick: yieldCallback((e) => {
      event({
        envelope: {
          event_type_id: "2048",
          event_type_version_id: "1",
          event_template_id: "126",
          event_template_version_id: "1"
        },
        clickstream_trigger: {
          trigger_type_nm: "interaction",
          trigger_location_nm: "cms",
          trigger_source_nm: "cms_button",
          trigger_object_nm: "no_trigger_object"
        },
        semantic: {
          semantic_event_nm: "cms_click"
        },
        cms_info: {
          block_id: e.target.id || "",
          block_type_cd: "button",
          block_displayed_txt: e.target.textContent,
          block_target_url: linkUrl || link,
          block_target_window_txt: opensInNewTab ? "_blank" : "",
          ...getCmsInfoForPage(pageProps)
        }
      });
    }), children: /* @__PURE__ */ jsx("a", { href, target: opensInNewTab ? "_blank" : void 0, rel: opensInNewTab ? "noreferrer" : void 0, children: content }) }, index);
  }
  return /* @__PURE__ */ jsx(ButtonWithTrigger, { triggerLink: linkUrl || link, type: "button", ...attributes, onMouseEnter: () => {
    event({
      envelope: {
        event_type_id: "2049",
        event_type_version_id: "1",
        event_template_id: "126",
        event_template_version_id: "1"
      },
      clickstream_trigger: {
        trigger_type_nm: "interaction",
        trigger_location_nm: "cms",
        trigger_source_nm: "cms_button",
        trigger_object_nm: "no_trigger_object"
      },
      semantic: {
        semantic_event_nm: "cms_hover"
      },
      cms_info: {
        block_id: attributes.id || "",
        block_type_cd: "button",
        block_displayed_txt: content,
        block_target_url: linkUrl || link,
        block_target_window_txt: opensInNewTab ? "_blank" : "",
        ...getCmsInfoForPage(pageProps)
      }
    });
  }, onClick: yieldCallback((e) => {
    event({
      envelope: {
        event_type_id: "2048",
        event_type_version_id: "1",
        event_template_id: "126",
        event_template_version_id: "1"
      },
      clickstream_trigger: {
        trigger_type_nm: "interaction",
        trigger_location_nm: "cms",
        trigger_source_nm: "cms_button",
        trigger_object_nm: "no_trigger_object"
      },
      semantic: {
        semantic_event_nm: "cms_click"
      },
      cms_info: {
        block_id: e.target.id || "",
        block_type_cd: "button",
        block_displayed_txt: e.target.textContent,
        block_target_url: linkUrl || link,
        block_target_window_txt: opensInNewTab ? "_blank" : "",
        ...getCmsInfoForPage(pageProps)
      }
    });
  }), children: content }, index);
};
const Button = withTrigger(BlockButton);
export {
  Button as default
};
